import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import Modal from "react-modal";
import Layouts from "../../layouts/layouts";
import Select from "react-select";
import { Country, State, City } from "country-state-city";
import { LoadScript, Autocomplete } from "@react-google-maps/api";

Modal.setAppElement("#root");

export default function Create_client() {
  const title = "Add Client";
  const navigate = useNavigate();

  const [hubs, setHubs] = useState([]);
  const [selectedCountryCode, setSelectedCountryCode] = useState("");
  const [selectedStateCode, setSelectedStateCode] = useState("");
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [autocomplete, setAutocomplete] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    contactname: "",
    phonenumber: "",
    designation: "",
    payout: "",
    payoutperpacket: "",
    id_hub: "",
    status: "Active",
    onBoardingDate: "",
    image_url: null,
    clientImage: null,
    shift: "Morning",
    adhocAmount: "",
    salary: "",
    buyerName: "",
    otRate: "",
    extrakmRate: "",
    coordinates: { latitude: "", longitude: "" },
    shift_hours: { check_in: "", check_out: "" },
    hasGST: false,
    gstDetails: {
      gstNumber: "",
      gstPercentage: "",
      tdsPercentage: "",
    },
  });

  const [errors, setErrors] = useState({});
  useEffect(() => {
    const fetchCountries = async () => {
      const countryData = Country.getAllCountries().map((country) => ({
        name: country.name,
        code: country.isoCode,
      }));
      setCountries(countryData);
    };
    fetchCountries();
  }, []);

  useEffect(() => {
    if (selectedCountryCode) {
      const stateData = State.getStatesOfCountry(selectedCountryCode).map(
        (state) => ({
          name: state.name,
          code: state.isoCode,
        }),
      );
      setStates(stateData);
      setCities([]);
    }
  }, [selectedCountryCode]);

  useEffect(() => {
    if (selectedStateCode && selectedCountryCode) {
      const cityData = City.getCitiesOfState(
        selectedCountryCode,
        selectedStateCode,
      ).map((city) => ({
        name: city.name,
        code: city.name,
      }));
      setCities(cityData);
    }
  }, [selectedStateCode, selectedCountryCode]);

  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name) {
      newErrors.name = "Client Name is required.";
    }
    if (!formData.payout) {
      newErrors.payout = "Payout is required.";
    }
    if (!formData.payoutperpacket) {
      newErrors.payoutperpacket = "Payouts Per Packet are required.";
    }
    if (!formData.id_hub) {
      newErrors.id_hub = "Hub is required.";
    }
    if (!formData.status) {
      newErrors.status = "status is required.";
    }
    if (!formData.clientImage)
      newErrors.clientImage = "Client Image is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onChangeHandler = (event) => {
    const { name, value, files } = event.target;

    // Keep GST fields grouped under gstDetails.
    if (["gstNumber", "gstPercentage", "tdsPercentage"].includes(name)) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        gstDetails: {
          ...prevFormData.gstDetails,
          [name]: value,
        },
      }));
      return;
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
    if (name === "latitude" || name === "longitude") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        coordinates: {
          ...prevFormData.coordinates,
          [name]: value,
        },
      }));
    } else if (name === "clientImage") {
      const file = files[0];
      if (file.size > 1048576) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          clientImage: "Image size must not exceed 1MB",
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          clientImage: "",
        }));
        setFormData((prevFormData) => ({
          ...prevFormData,
          clientImage: file,
        }));
      }
    } else if (name === "check_in" || name === "check_out") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        shift_hours: {
          ...prevFormData.shift_hours,
          [name]: value,
        },
      }));
    }
  };

  const onLoad = (autoComp) => {
    setAutocomplete(autoComp);
  };

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      setFormData((prevFormData) => ({
        ...prevFormData,
        coordinates: { latitude: lat, longitude: lng },
      }));
    } else {
      console.log("Autocomplete is not loaded yet!");
    }
  };
  const onSubmitHandler = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }
    if (errors.clientImage) {
      alert(errors.clientImage);
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No token found");
      return;
    }

    const data = new FormData();
    data.append("name", formData.name);
    data.append("payout", formData.payout);
    data.append("adhocAmount", formData.adhocAmount);
    data.append("salary", formData.salary);
    data.append("payoutperpacket", formData.payoutperpacket);
    data.append("onBoardingDate", formData.onBoardingDate);
    data.append("id_hub", formData.id_hub);
    data.append("status", formData.status);
    data.append("clientImage", formData.clientImage);
    data.append("shift", formData.shift);
    data.append("coordinates[latitude]", formData.coordinates.latitude);
    data.append("coordinates[longitude]", formData.coordinates.longitude);
    data.append("contactname", formData.contactname);
    data.append("phonenumber", formData.phonenumber);
    data.append("designation", formData.designation);
    data.append("shift_hours[check_in]", formData.shift_hours.check_in);
    data.append("shift_hours[check_out]", formData.shift_hours.check_out);

    data.append("buyerName", formData.buyerName);
    data.append("otRate", formData.otRate || "0");
    data.append("extrakmRate", formData.extrakmRate || "0");
    // Always send the GST toggle. Send the tax details only when GST applies.
    data.append("hasGST", String(formData.hasGST));
    if (formData.hasGST) {
      data.append(
        "gstDetails",
        JSON.stringify({
          gstNumber: formData.gstDetails.gstNumber.trim().toUpperCase(),
          gstPercentage: formData.gstDetails.gstPercentage,
          tdsPercentage: formData.gstDetails.tdsPercentage,
        }),
      );
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/client/new`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.status === 201) {
        navigate("/client");
      } else {
        console.error("Submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    const fetchHubs = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/hubs`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setHubs(response.data.hubs);
      } catch (error) {
        console.error("Error fetching hub:", error);
        setHubs([]);
      }
    };
    fetchHubs();
  }, []);

  const hubOptions = hubs.map((hub) => ({
    value: hub._id,
    label: hub.name,
  }));

  const handleHubChange = (selectedOption) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      id_hub: selectedOption ? selectedOption.value : "",
    }));
  };

  return (
    <>
      <Layouts />
      <div className="container-fluid">
        <Breadcrumb title={title} brad={brad} />
        <form
          className="card"
          style={{ borderTop: "2px solid #4723d9" }}
          onSubmit={onSubmitHandler}
        >
          <div className="card-header d-flex justify-content-between border-bottom pb-1">
            <div className="">{title}</div>
            <div className="btn btn-info btn-sm" onClick={() => navigate(-1)}>
              Back
            </div>
          </div>
          <div className="card-body">
            <div className="row justify-content-center">
              <div className="col-md-6 mt-3">
                <label htmlFor="name">
                  <b>Name *</b>
                </label>
                <input
                  type="text"
                  placeholder="Client Name"
                  className="form-control"
                  name="name"
                  onChange={onChangeHandler}
                  value={formData.name || ""}
                />
                {errors.name && <p className="text-danger">{errors.name}</p>}
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="payout">
                  <b>Payout *</b>
                </label>
                <input
                  type="number"
                  placeholder="Payout"
                  className="form-control"
                  name="payout"
                  onChange={onChangeHandler}
                  value={formData.payout || ""}
                />
                {errors.payout && (
                  <p className="text-danger">{errors.payout}</p>
                )}
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="payoutperpacket">
                  <b>Payouts Per Packet *</b>
                </label>
                <input
                  type="number"
                  placeholder="Payouts per packet"
                  className="form-control"
                  name="payoutperpacket"
                  onChange={onChangeHandler}
                  value={formData.payoutperpacket || ""}
                />
                {errors.payoutperpacket && (
                  <p className="text-danger">{errors.payoutperpacket}</p>
                )}
              </div>

              {/* Buyer Name */}
              <div className="col-md-6 mt-3">
                <label htmlFor="buyerName">
                  <b>Buyer Name</b>
                </label>
                <input
                  id="buyerName"
                  type="text"
                  placeholder="Enter Buyer Name"
                  className="form-control"
                  name="buyerName"
                  onChange={onChangeHandler}
                  value={formData.buyerName}
                />
              </div>

              {/* Overtime Rate */}
              <div className="col-md-6 mt-3">
                <label htmlFor="otRate">
                  <b>OT Rate</b>
                </label>
                <input
                  id="otRate"
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="Enter OT Rate"
                  className="form-control"
                  name="otRate"
                  onChange={onChangeHandler}
                  value={formData.otRate}
                />
              </div>

              {/* Extra KM Rate */}
              <div className="col-md-6 mt-3">
                <label htmlFor="extrakmRate">
                  <b>Extra KM Rate</b>
                </label>
                <input
                  id="extrakmRate"
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="Enter Extra KM Rate"
                  className="form-control"
                  name="extrakmRate"
                  onChange={onChangeHandler}
                  value={formData.extrakmRate}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="hub">
                  <b>Hub *</b>
                </label>
                <Select
                  name="id_hub"
                  options={hubOptions}
                  onChange={handleHubChange}
                  value={hubOptions.find(
                    (option) => option.value === formData.id_hub,
                  )}
                  isClearable
                  placeholder="Select Hub"
                  className="basic-single"
                  classNamePrefix="select"
                />
                {errors.id_hub && (
                  <p className="text-danger">{errors.id_hub}</p>
                )}
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="to">
                  <b>On-Boarding Date *</b>
                </label>
                <input
                  type="date"
                  name="onBoardingDate"
                  className="form-control"
                  value={formData.onBoardingDate}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="shift">
                  <b> Shift Timings * </b>
                </label>
                <select
                  name="shift"
                  className="form-control"
                  value={formData.shift || "Morning"}
                  onChange={onChangeHandler}
                >
                  <option value="">Select Shift</option>
                  <option value="Morning">Morning</option>
                  <option value="Evening">Evening</option>
                  <option value="FullDay">Full-Day</option>
                </select>
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="">
                  <b>Location</b>
                </label>
                <LoadScript
                  googleMapsApiKey={process.env.REACT_APP_BASE_API}
                  libraries={["places"]}
                >
                  <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
                    <input
                      type="text"
                      placeholder="Search places..."
                      className="form-control"
                    />
                  </Autocomplete>
                </LoadScript>
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="coordinates">
                  <b>Coordinates *</b>
                </label>
                <input
                  type="text"
                  name="coordinates"
                  placeholder="Latitude, Longitude"
                  className="form-control"
                  value={`${formData.coordinates.latitude}, ${formData.coordinates.longitude}`}
                  readOnly
                />
                {errors.coordinates && (
                  <small className="text-danger">{errors.coordinates}</small>
                )}
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="adhocAmount">
                  <b>Adhoc Amount </b>
                </label>
                <input
                  type="number"
                  placeholder="Adhoc Amount"
                  className="form-control"
                  name="adhocAmount"
                  onChange={onChangeHandler}
                  value={formData.adhocAmount || ""}
                />
              </div>
              <div className="col-md-6 mt-2">
                <label htmlFor="clientImage">
                  <b>Client Image * </b>
                </label>
                <input
                  type="file"
                  name="clientImage"
                  placeholder="Client Image"
                  className="form-control"
                  onChange={onChangeHandler}
                  accept="image/*"
                />
                {errors.clientImage && (
                  <small className="text-danger">{errors.clientImage}</small>
                )}
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="status">
                  <b>Client status *</b>
                </label>
                <select
                  name="status"
                  className="form-control"
                  value={formData.status}
                  onChange={onChangeHandler}
                >
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
                {errors.status && (
                  <p className="text-danger">{errors.status}</p>
                )}
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="hasGST" className="d-block">
                  <b>GST Applicable?</b>
                </label>
                <div className="form-check mt-2">
                  <input
                    id="hasGST"
                    type="checkbox"
                    className="form-check-input"
                    checked={formData.hasGST}
                    onChange={(event) => {
                      const hasGST = event.target.checked;
                      setFormData((prevFormData) => ({
                        ...prevFormData,
                        hasGST,
                        // Clear tax fields when GST is switched off.
                        gstDetails: hasGST
                          ? prevFormData.gstDetails
                          : {
                              gstNumber: "",
                              gstPercentage: "",
                              tdsPercentage: "",
                            },
                      }));
                    }}
                  />
                  <label className="form-check-label" htmlFor="hasGST">
                    GST is applicable for this client
                  </label>
                </div>
              </div>

              {formData.hasGST && (
                <>
                  <div className="col-md-6 mt-3">
                    <label htmlFor="gstNumber">
                      <b>GST Number *</b>
                    </label>
                    <input
                      id="gstNumber"
                      type="text"
                      placeholder="Enter GST number"
                      className="form-control"
                      name="gstNumber"
                      value={formData.gstDetails.gstNumber}
                      onChange={onChangeHandler}
                      required={formData.hasGST}
                    />
                  </div>
                  <div className="col-md-6 mt-3">
                    <label htmlFor="gstPercentage">
                      <b>GST Percentage (%) *</b>
                    </label>
                    <input
                      id="gstPercentage"
                      type="number"
                      placeholder="Enter GST percentage"
                      className="form-control"
                      name="gstPercentage"
                      min="0"
                      max="100"
                      step="0.01"
                      value={formData.gstDetails.gstPercentage}
                      onChange={onChangeHandler}
                      required={formData.hasGST}
                    />
                  </div>
                  <div className="col-md-6 mt-3">
                    <label htmlFor="tdsPercentage">
                      <b>TDS Percentage (%) *</b>
                    </label>
                    <input
                      id="tdsPercentage"
                      type="number"
                      placeholder="Enter TDS percentage"
                      className="form-control"
                      name="tdsPercentage"
                      min="0"
                      max="100"
                      step="0.01"
                      value={formData.gstDetails.tdsPercentage}
                      onChange={onChangeHandler}
                      required={formData.hasGST}
                    />
                  </div>
                </>
              )}

              <div className="col-md-6 mt-3">
                <label htmlFor="contactname">
                  <b>Contact Name </b>
                </label>
                <input
                  type="text"
                  placeholder="Contact Name"
                  className="form-control"
                  name="contactname"
                  onChange={onChangeHandler}
                  value={formData.contactname || ""}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="phonenumber">
                  <b>Phonenumber </b>
                </label>
                <input
                  type="number"
                  placeholder="Phone-number"
                  className="form-control"
                  name="phonenumber"
                  onChange={onChangeHandler}
                  value={formData.phonenumber || ""}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="designation">
                  <b>Designation </b>
                </label>
                <input
                  type="text"
                  placeholder="Designation"
                  className="form-control"
                  name="designation"
                  onChange={onChangeHandler}
                  value={formData.designation || ""}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="shift_hours.check_in">
                  <b>Shift-in Time </b>
                </label>
                <input
                  type="time"
                  className="form-control"
                  name="check_in"
                  onChange={onChangeHandler}
                  value={formData.shift_hours.check_in}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="shift_hours.check_out">
                  <b>Shift-out Time </b>
                </label>
                <input
                  type="time"
                  className="form-control"
                  name="check_out"
                  onChange={onChangeHandler}
                  value={formData.shift_hours.check_out}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="salary">
                  <b>Client Salary ( Per Trip) </b>
                </label>
                <input
                  type="number"
                  placeholder="Client Salary"
                  className="form-control"
                  name="salary"
                  onChange={onChangeHandler}
                  value={formData.salary || ""}
                />
              </div>

              <div className="col-md-6 mt-3"></div>
            </div>
            <button type="submit" className="btn btn-primary btn-sm mt-3">
              Add Client
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
